import { QK } from 'ck-queries';
import { ThemeDto } from './types';
import { fetchWithErrorThrowing } from 'ck-utils';
import { formatThemeData } from './localUtils';
import { useQuery } from '@tanstack/react-query';

// Query hook
export const useThemeUpcoming = () =>
  useQuery({
    queryKey: QK.themes.upcoming,
    queryFn: getThemesUpcoming,
  });

// Query function
export async function getThemesUpcoming(): Promise<ThemeDto[]> {
  const res = await fetchWithErrorThrowing('/themes/upcoming', {
    method: 'GET',
  });

  const data: { themes: ThemeDto[] } = await res.json();

  return formatThemeData(data.themes);
}
